<div class="margin-bottom-2 margin-top-2 required-text"><span class="required-asterisk">*</span> = Required</div>